import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { GrowthBook } from '@growthbook/growthbook-react'
import { getCurrentEnv, getMobileOperatingSystem } from 'helpers'

import {
  selectCurrentVariantCohort,
  selectGrowthBookExperiments,
  selectLanguage,
} from 'root-redux/selects/common'
import { selectUUID, selectUserCountryCode } from 'root-redux/selects/user'

import { eventLogger } from 'services/eventLogger.service'

import { CurrentEnvironment } from 'root-constants/common'

const PROD_GROWTHBOOK_CLIENT_KEY = 'sdk-sThd75Q9PkVN8uxs'
const DEV_GROWTHBOOK_CLIENT_KEY = 'sdk-XnCG16FsT37eq2Yl'

const clientKey =
  getCurrentEnv() === CurrentEnvironment.PROD
    ? PROD_GROWTHBOOK_CLIENT_KEY
    : DEV_GROWTHBOOK_CLIENT_KEY

export const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  enableDevMode: true,
  clientKey,
})

export const useGrowthBook = (): boolean => {
  const [isGrowthBookReady, setIsGrowthBookReady] = useState(false)

  const uuid = useSelector(selectUUID)
  const cohort = useSelector(selectCurrentVariantCohort)
  const countryCode = useSelector(selectUserCountryCode)
  const language = useSelector(selectLanguage)
  const experimentsMap = useSelector(selectGrowthBookExperiments)

  useEffect(() => {
    growthbook.init({ streaming: true }).then(() => setIsGrowthBookReady(true))
  }, [])

  useEffect(() => {
    const mobileOperatingSystem = getMobileOperatingSystem()

    growthbook.setAttributes({
      ...growthbook.getAttributes(),
      id: uuid,
      cohort,
      mobileOperatingSystem,
      countryCode,
      language,
      url: window.location.href,
    })
  }, [cohort, uuid, countryCode, language])

  useEffect(() => {
    growthbook.subscribe((experiment, result) => {
      const experimentKey = experiment.key || ''
      const variantId = String(result.variationId)

      if (
        !experimentsMap ||
        !experimentsMap[experimentKey] ||
        !result.hashUsed
      ) {
        return
      }

      eventLogger.logGrowthbookAbSegmentName({
        variantId,
        experimentKey,
        variantName: experimentsMap[experimentKey][variantId],
      })
    })
  }, [experimentsMap])

  return isGrowthBookReady
}
